import { IconButton } from "$components/button/icon-button";
import { ArrowBackIcon } from "$components/icons";
import { UnstyledLink } from "$components/link";
import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  title: string | React.ReactNode;
  backToLink?: string;
  children?: React.ReactNode;
}

const InventoryTitleRow: React.FunctionComponent<Props> = ({
  title,
  backToLink,
  children,
}) => {
  const navigate = useNavigate();

  return (
    <Box marginBottom={2}>
      <Grid
        container
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item xs={12} sm="auto" md="auto">
          <Box display="flex" alignItems="center">
            <Box marginRight={1}>
              {backToLink ? (
                <UnstyledLink to={backToLink} onClick={() => navigate(-1)}>
                  <IconButton color="secondary">
                    <ArrowBackIcon />
                  </IconButton>
                </UnstyledLink>
              ) : (
                <IconButton
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <ArrowBackIcon />
                </IconButton>
              )}
            </Box>
            <Typography variant="h3">{title}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm="auto">
          {children}
        </Grid>
      </Grid>
    </Box>
  );
};

export default InventoryTitleRow;
